var _defs, _path, _path2, _rect, _circle, _circle2, _path3, _ellipse, _ellipse2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new -281.85 -2.67 1024 1024",
    height: "1024px",
    viewBox: "-281.85 -2.67 1024 1024",
    width: "1024px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504.682,259.996c0,2.025-1.642,3.667-3.667,3.667l0,0c-2.025,0-3.666-1.642-3.666-3.667v-57.999  c0-2.025,1.641-3.667,3.666-3.667l0,0c2.025,0,3.667,1.642,3.667,3.667V259.996z",
    fill: "#696971"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M502.35,73v872.66c0,37.56-30.45,68-68,68H75.68  c-37.55,0-68-30.44-68-68V343.81c-0.55-0.18-1.04-0.49-1.44-0.89c-0.66-0.66-1.07-1.58-1.07-2.59v-58c0-1.63,1.05-3,2.51-3.49  v-15.36c-0.55-0.19-1.04-0.49-1.44-0.89c-0.66-0.66-1.07-1.58-1.07-2.59v-58c0-1.63,1.05-3,2.51-3.49v-38.45  C6.15,159.7,5,158.32,5,156.66v-30c0-0.97,0.39-1.84,1.03-2.47c0.45-0.45,1.01-0.78,1.65-0.93V73c0-37.56,30.45-68,68-68h358.67  C471.9,5,502.35,35.44,502.35,73z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 777,
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 10,
    width: 438,
    x: 36.015,
    y: 120.496
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 255.015,
    cy: 37.746,
    fill: "none",
    r: 5,
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 186.167,
    cy: 65.746,
    fill: "none",
    r: 7.5,
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M289.265,65.996c0,2.347-1.903,4.25-4.25,4.25h-60  c-2.347,0-4.25-1.903-4.25-4.25l0,0c0-2.347,1.903-4.25,4.25-4.25h60C287.362,61.746,289.265,63.649,289.265,65.996L289.265,65.996z  ",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.015,
    cy: 952.496,
    fill: "none",
    rx: 31.5,
    ry: 32,
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 193.667,
    cy: 58.496,
    fill: "none",
    rx: 0,
    ry: 0.25,
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c4c6d8c344b8180393bfbbcf31396d6e.svg";
export { ForwardRef as ReactComponent };